import { render, staticRenderFns } from "./userrefundlist.vue?vue&type=template&id=b8a5607e&scoped=true"
import script from "./userrefundlist.vue?vue&type=script&lang=js"
export * from "./userrefundlist.vue?vue&type=script&lang=js"
import style0 from "./userrefundlist.vue?vue&type=style&index=0&id=b8a5607e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5607e",
  null
  
)

export default component.exports